import React from 'react';

const testimonials = [
  {
    id: 1,
    text: '“What happens when love never truly dies, even after decades of silence? The Arid Lips is a hauntingly beautiful story about two souls who find their way back to each other.”',
    author: 'Mansi Ramwani',
    detail: 'Reader · United States',
  },
  {
    id: 2,
    text: '“I really enjoyed reading The Arid Lips. The grandmother’s courage in holding the family together felt so honest—her strength anchors the entire story.”',
    author: 'Vishal Srivastava',
    detail: 'Reader · United States',
  },
  {
    id: 3,
    text: '“I felt connected to both characters. Aarjay writes in a way that makes you feel like their confidante—and the lessons linger long after.”',
    author: 'Anne-Britton Arnett',
    detail: 'Reader · United States',
  },
  {
    id: 4,
    text: '“Some books are read; others are felt. The Arid Lips is the latter—it blooms slowly inside you and refuses to let go.”',
    author: 'RS',
    detail: 'Reader · United States',
  },
  {
    id: 5,
    text: '“Written with passion and precision. The story is intimate, the expression tender, and the characters feel beautifully familiar.”',
    author: 'Shyam Sharma',
    detail: 'Reader · India',
  },
];

const Testimonials: React.FC = () => {
  return (
    <section id="testimonials" className="section section--muted">
      <div className="wrapper">
        <div className="section__header">
          <span className="eyebrow">Reader Reflections</span>
          <h2 className="headline">“Some Hearts Break Quietly”</h2>
          <p className="lead">
            The Arid Lips has resonated with readers across continents—kindred spirits who recognise
            themselves in the quiet ache of the story.
          </p>
        </div>

        <div className="card-grid">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="avatar">{testimonial.author[0]}</div>
              <p className="testimonial-card__quote">{testimonial.text}</p>
              <p className="testimonial-card__meta">
                {testimonial.author} · {testimonial.detail}
              </p>
            </div>
          ))}
        </div>

        <div className="surface surface--subtle" style={{ marginTop: '3rem' }}>
          <blockquote className="quote">
            “Every story I write reaches for the reader who still believes their tenderness is an
            act of rebellion.”
            <small>— Aarjay S</small>
          </blockquote>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

